declare global {
    interface Window {
        dataLayer: Array<{ event: string;[key: string]: unknown }>;
    }
}

export default function initgaSingle() {
    const $gaSingleWrapper = document.querySelectorAll('body');

    $gaSingleWrapper.forEach($element => {
        new GASingle($element);
    });
}

class GASingle {
    $element: Element;
    onDocumentClick: (e: MouseEvent) => void;

    constructor($element: Element) {
        this.$element = $element;
        this.init();

    }

    init() {
        const bodySingle = this.$element.classList.contains('single');
        if (bodySingle) {
            const $title = this.$element.querySelector('.header-single .title')?.textContent || '';
            const $cat = this.$element.querySelector('.header-single .archive-link')?.textContent || '';
            document.addEventListener('DOMContentLoaded', () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    "event": "view_resource",
                    "ressource_category": `${$cat}`,
                    "ressource_name": `${$title}`
                });
            });
        } else if (this.$element.classList.contains('white_paper')){
            const $title = document.title;
            document.addEventListener('DOMContentLoaded', () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    "event": "view_resource",
                    "ressource_category": 'white_paper',
                    "ressource_name": `${$title}`
                });
            });
        } else if (this.$element.classList.contains('webinar')){
            const $title = document.title;
            document.addEventListener('DOMContentLoaded', () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    "event": "view_resource",
                    "ressource_category": 'webinar',
                    "ressource_name": `${$title}`
                });
            });
        }
    }
}